import { LISTAR_PONTOS_EMBARQUE_CIDADE, LIMPAR_PONTOS_EMBARQUE_CIDADE } from '../../actions/types'

const initialState = []

export default function reducerPontosEmbarqueCidade(state = initialState, action = {}) {
  switch (action.type) {
    case LISTAR_PONTOS_EMBARQUE_CIDADE: {
      const pontos = action.payload.data
      return pontos || []
    }
    case LIMPAR_PONTOS_EMBARQUE_CIDADE:
      return []
    default:
      return state
  }
}
